import { Feather } from "lucide-react";

// Rotating daily quotes from Chief Editor JAKIR MOMIN
const QUOTES = [
  "सच्चा पत्रकार वह है जो कलम से डरता नहीं और सच से भागता नहीं।",
  "समाचार की सबसे बड़ी ताक़त उसकी निष्पक्षता होती है।",
  "जब तक पाठक भरोसा करे — कागज़ ज़िंदा है।",
  "छोटी ख़बर भी बड़ी बदलाव ला सकती है — बशर्ते सच हो।",
  "मीडिया लोकतंत्र का चौथा स्तंभ है, विज्ञापन नहीं।",
  "ज़मीन से जुड़ी पत्रकारिता ही असली पत्रकारिता है।",
  "ख़बर उसी की, जिसकी आवाज़ किसी को न सुनायी दे।",
  "पत्रकारिता में डर नहीं, दृष्टि होनी चाहिए।",
  "हर सुबह एक नयी ज़िम्मेदारी लेकर आती है — सच बताने की।",
  "अख़बार का हर शब्द किसी की ज़िंदगी से जुड़ा होता है।",
  "ईमानदार ख़बर, कभी पुरानी नहीं होती।",
  "क़लम की धार तलवार से तेज़ होती है — इसे संभालकर चलायें।",
  "जनहित सर्वोपरि — यही हमारा मूलमंत्र है।",
  "स्थानीय ख़बर ही राष्ट्रीय बदलाव की नींव है।",
  "पत्रकारिता का धर्म — निर्भीक होना, निष्पक्ष रहना।",
  "जब सत्ता चुप हो जाए, तब आवाज़ अख़बार बनता है।",
  "समाज का आईना बनने के लिए, आईने की तरह साफ़ रहना पड़ता है।",
  "हम विज्ञापन नहीं, विश्वास बेचते हैं।",
  "सुर्खी पढ़वाने के लिए नहीं, सत्य सुनाने के लिए बनती है।",
  "अफ़वाहें ख़बर नहीं होतीं — सत्यापन ही पहला कर्तव्य है।",
  "एक अच्छा संपादक, एक अच्छा श्रोता भी होता है।",
  "आवाज़ बुलंद हो, लेकिन शब्द नपे-तुले हों।",
  "गाँव की गली से लेकर दिल्ली दरबार तक — हर आवाज़ मायने रखती है।",
  "ख़बर लिखते समय, पाठक की आँखों में देखिये।",
  "पत्रकारिता कोई पेशा नहीं, दायित्व है।",
  "जो सच्चाई कड़वी हो — उसे भी उतनी ही स्पष्टता से लिखिए।",
  "किसान की चिंता, माँ की ममता, बच्चे की आशा — सब ख़बर हैं।",
  "समाज के दर्द को महसूस किए बिना, पत्रकारिता संभव नहीं।",
  "हम इतिहास लिखते नहीं — हर दिन बनाते हैं।",
  "इंडियन-न्यूज़-21 — भारत की आवाज़, भारत के लिए।",
];

function todayIndex() {
  const start = new Date(new Date().getFullYear(), 0, 0);
  const diff = new Date() - start;
  const day = Math.floor(diff / 86400000);
  return day % QUOTES.length;
}

export default function EditorSignatureBox() {
  const quote = QUOTES[todayIndex()];
  return (
    <aside
      className="my-10 relative rounded-xl overflow-hidden bg-gradient-to-br from-[#0F172A] via-[#111827] to-[#1E3A8A] text-white shadow-xl"
      data-testid="editor-signature-box"
    >
      <div className="absolute -top-10 -right-6 opacity-[0.06] text-[220px] font-devnagri-heading font-black leading-none pointer-events-none select-none">
        "
      </div>
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, #fbbf24 0 1px, transparent 1px 14px)",
        }}
      />
      <div className="relative p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start md:items-center">
        <div className="shrink-0">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center text-[#0F172A] shadow-lg ring-4 ring-amber-500/20">
            <Feather className="w-7 h-7" strokeWidth={2.5}/>
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="uppercase tracking-[0.28em] text-[10px] text-amber-300 font-bold mb-2">
            प्रधान संपादक की कलम से · Editor's Note
          </div>
          <blockquote className="font-serif-hi text-lg md:text-2xl font-semibold leading-relaxed italic text-white">
            &ldquo;{quote}&rdquo;
          </blockquote>
          <div className="mt-5 flex items-end justify-between flex-wrap gap-3">
            <div>
              <div
                className="font-black text-amber-300 text-2xl md:text-3xl tracking-wider"
                style={{ fontFamily: "'Times New Roman', serif", fontStyle: "italic" }}
              >
                JAKIR MOMIN
              </div>
              <div className="h-[2px] w-40 bg-gradient-to-r from-amber-400 to-transparent mt-1"></div>
              <div className="text-slate-300 text-xs mt-1.5 tracking-wide">
                Chief Editor · INDIAN-NEWS-21
              </div>
            </div>
            <div className="text-right text-[10px] uppercase tracking-widest text-slate-400">
              <div>दैनिक विचार</div>
              <div className="text-amber-300/80">
                {new Date().toLocaleDateString("hi-IN", {
                  day: "numeric", month: "long", year: "numeric",
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
